import { MdInfo } from "react-icons/md";
import { GiPositionMarker } from "react-icons/gi";
import { useMemo, useState, useEffect, useCallback, useContext } from "react";
import { Menu as AntdMenu, Tooltip } from "antd";
import { useLocation, useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";
import { DialogContext } from "../../../../hooks/dialog/context";
import useNotification from "../../../../hooks/newUXNotification";
import { financialSingleSignOn } from "../../../../redux/modules/billing/actions";
import { getGuests } from "../../../../redux/modules/guests/actions";
import { checkMandatoryDocuments } from "../../../../redux/modules/documentRequired/actions";
import { validateLeadsterPlusMenuAccess } from "../../../../redux/modules/leadsterPlus/actions";
import Basket from "../../../../newUXAssets/icons/Basket";
import ChatDots from "../../../../newUXAssets/icons/ChatDots";
import Files from "../../../../newUXAssets/icons/Files";
import IdentificationCard from "../../../../newUXAssets/icons/IdentificationCard";
import ListChecks from "../../../../newUXAssets/icons/ListChecks";
import Question from "../../../../newUXAssets/icons/Question";
import UserCircle from "../../../../newUXAssets/icons/UserCircle";
import Billing from "../../../../newUXAssets/icons/Billing";
import Guests from "../../../../newUXAssets/icons/Guests";
import Key from "../../../../newUXAssets/icons/Key";
import Package from "../../../../newUXAssets/icons/Package";
import FileArrowDown from "../../../../newUXAssets/icons/FileArrowDown";
import UserSwitch from "../../../../newUXAssets/icons/UserSwitch";
import LoaderFill from "../../../../newUXAssets/icons/LoaderFill";
import GuestsModal from "./GuestsModal";
import FinancialModal from "./FinancialModal";
import { ImageIcon } from "../../../../newUXAssets/icons/Image";
import Movie from "../../../../newUXAssets/icons/Movie";
import { getInformaAcademyEventBanner } from "../../../../redux/modules/informaAcademy/actions";
import { hasAccessToManual } from "../../../../redux/modules/eventManual/action";
import BookIcon from "../../../../newUXAssets/icons/Book";
import useEventEditionCode from "../../../../hooks/useEventEditionCode";
import useEventCode from "../../../../hooks/useEventCode";
import { AiOutlineHome } from "react-icons/ai";

const items = [
  {
    key: "0",
    path: "/home",
  },
  {
    key: "1",
    path: "/accounts-users",
  },
  {
    key: "2",
    path: "/checklist",
  },
  {
    key: "3",
    path: "/event-manual",
  },
  {
    key: "4",
    path: "/ai-creator",
  },
  {
    key: "5",
    path: "/informa-academy",
  },
  {
    key: "6",
    path: "/billing",
  },
  {
    key: "7",
    path: "/user",
    urls: [
      {
        url: "/user/view",
        permission: "EDIT_EXHIBITOR_PROFILE_INFORMATION",
      },
      {
        url: "/user/view",
        permission: "EDIT_PROFILE_INFORMATION",
      },
      {
        url: "/user/terms-of-use",
        permission: "ACCESS_TERMS_OF_USE",
      },
    ],
  },
  {
    key: "8",
    path: "/associate-company",
  },
  {
    key: "9",
    path: "/document",
    urls: [
      {
        url: "/document/not-send",
        permission: "MANAGE_DOCUMENT_NOT_SEND",
      },
    ],
  },
  {
    key: "10",
    path: "/contract",
  },
  {
    key: "11",
    path: "/credentials",
    urls: [
      {
        url: "/credentials/associate",
        permission: "MANAGE_CREDENTIALS",
      },
      {
        url: "/credentials/register",
        permission: "MANAGE_ASSOCIATE_COLLABORATOR",
      },
      {
        url: "/credentials/schedule",
        permission: "MANAGE_CREDENTIALS",
      },
      {
        url: "/credentials/transfer",
        permission: "TRANSFER_CREDENTIALS",
      },
    ],
  },
  {
    key: "12",
    path: "/leadsterplus",
  },
  {
    key: "13",
    path: "/ecommerce",
  },
  {
    key: "14",
    path: "/contact",
  },
  {
    key: "15",
    path: "/guests",
  },
  {
    key: "16",
    path: "/faq",
  },
];

const Menu = () => {
  const { pathname } = useLocation();
  const history = useHistory();
  const intl = useIntl();
  const notification = useNotification();
  const dispatch = useDispatch();
  const { createDialog } = useContext(DialogContext);
  const [menuItems, setMenuItems] = useState([]);
  const { user, adminToken, permission } = useSelector((state) => state.auth);
  const { contract, event } = useSelector((state) => state.initialSettings);
  const { hasMandatoryDocuments } = useSelector(
    (state) => state.documentRequired
  );
  const [currentEvent, setCurrentEvent] = useState();
  const [isGuestsActive, setIsGuestsActive] = useState(false);
  const [currentOpportunity, setCurrentOpportunity] = useState();
  const [isLeadsterPlusActive, setIsLeadsterPlusActive] = useState(false);
  const [eventHasBanner, setEventHasBanner] = useState(false);
  const { allowAccess } = useSelector((state) => state.informaAcademy);
  const { allowManualAccess, eventEditionCode } = useSelector(
    (state) => state.eventManual
  );
  const hasAccessToCreator =
    String(process.env.REACT_APP_HAS_ACCESS_TO_CREATOR).toLowerCase() ===
    "true";
  const mainPath = `/${pathname.split("/")[1]}`;

  // Carregar dados do contrato (dispara a busca quando event/contract mudam)
  useEventEditionCode();

  // Ler o eventCode do Redux (sem disparar nova busca)
  const eventCode = useEventCode();

  const selectedKey = useMemo(() => {
    const findedItem = items.find((item) => item.path === mainPath);

    if (!findedItem) return "";

    return findedItem.key;
  }, [mainPath, user]);

  const generateHiddenInputAndAppend = (name, value, form) => {
    const field = document.createElement("input");
    field.type = "hidden";
    field.name = name;
    field.value = value;
    form.appendChild(field);
  };

  const callbackSuccess = useCallback(({ token, url }) => {
    const form = document.createElement("form");
    form.method = "post";
    form.action = url;
    form.target = "_blank";

    generateHiddenInputAndAppend("bypass_key", token, form);

    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  }, []);

  const callbackError = useCallback(
    (codeError) => {
      if (codeError === -22000) {
        notification.displayInfo(
          intl.formatMessage({
            id: "api.error." + codeError,
          }),
          "financial-Single-SignOn-info"
        );
      } else {
        notification.displayError(
          intl.formatMessage({
            id: "api.error." + codeError,
          }),
          "financial-Single-SignOn-info"
        );
      }
    },
    [intl, notification]
  );

  const handleFinancialSingleSignOn = useCallback(
    (event, contract) => {
      if (!contract.value || !event.value) {
        notification.displayInfo(
          intl.formatMessage({ id: "error.contract_not_selected" }),
          "event-not-selected-message"
        );
        return;
      }
      dispatch(financialSingleSignOn(callbackSuccess, callbackError));
    },
    [event, contract]
  );

  const handleModalFinancial = () => {
    if (!contract.value || !event.value) {
      notification.displayInfo(
        intl.formatMessage({ id: "error.contract_not_selected" }),
        "event-not-selected-message"
      );
      return;
    }

    createDialog({
      id: "modal-financial",
      Component: FinancialModal,
    });
  };

  const alternativeCallBackSuccessGuests = useCallback(() => {
    setIsGuestsActive(true);
  }, []);

  const alternativeCallBackErrorGuests = useCallback(() => {
    setIsGuestsActive(false);
  }, []);

  const alternativeCallBackSuccessLeadsterPlus = useCallback(() => {
    setIsLeadsterPlusActive(true);
  }, []);

  const alternativeCallBackErrorLeadsterPlus = useCallback(() => {
    setIsLeadsterPlusActive(false);
  }, []);

  const handleCheckMandatoryDocuments = useCallback(() => {
    if (!contract?.value) return;

    dispatch(
      checkMandatoryDocuments(
        contract.value,
        (hasMandatory) => {
          console.log("hasMandatory ", hasMandatory);
        },
        (error) => {
          console.error("Error checking mandatory documents:", error);
        }
      )
    );
  }, [contract?.value, dispatch]);

  const handleModalGuests = useCallback(
    (data) => {
      createDialog({
        id: "modal-guests",
        Component: GuestsModal,
        props: {
          idContract: contract?.value,
          eventId: event?.value,
          data,
        },
      });
    },
    [contract?.value, createDialog, event?.value]
  );

  const handleGuests = () => {
    if (!contract.value || !event.value) {
      notification.displayInfo(
        intl.formatMessage({ id: "error.contract_not_selected" }),
        "event-not-selected-message"
      );
      return;
    }

    dispatch(
      getGuests(
        {
          eventId: event.value,
        },
        handleModalGuests,
        callbackError
      )
    );
  };

  const handleLeadsterPlus = () => {
    if (!contract.value || !event.value) {
      notification.displayInfo(
        intl.formatMessage({ id: "error.contract_not_selected" }),
        "event-not-selected-message"
      );
      return;
    }

    dispatch(
      validateLeadsterPlusMenuAccess(
        {
          opportunityId: contract.value,
        },
        handleGoToLeadsterPlusPage,
        callbackError
      )
    );
  };

  const handleGoToLeadsterPlusPage = () => {
    history.push("/leadsterplus");
  };

  const onClickGoToPage = (path) => () => history.push(path);

  const getFirstUrlToPage = ({ urls }) => {
    const firstUrl = urls?.find((item) => permission.includes(item.permission));

    if (firstUrl?.url) {
      history.push(firstUrl.url);
    }
  };

  const getIconColor = (uri) => {
    if (pathname.includes(uri)) return "white";
    return "#444444";
  };

  useEffect(() => {
    if (!event) {
      setCurrentEvent();
      return;
    }
    if (currentEvent !== event?.value) {
      setCurrentEvent(event?.value);
      return;
    }
  }, [event]);

  useEffect(() => {
    if (!currentEvent) {
      setIsGuestsActive(false);
      setEventHasBanner(false);
      return;
    }

    dispatch(
      getGuests(
        {
          eventId: currentEvent,
        },
        alternativeCallBackSuccessGuests,
        alternativeCallBackErrorGuests
      )
    );

    dispatch(
      getInformaAcademyEventBanner({
        eventId: currentEvent,
      })
    );

    dispatch(hasAccessToManual());
  }, [currentEvent]);

  useEffect(() => {
    if (!contract) {
      setCurrentOpportunity();
      return;
    }
    if (currentOpportunity !== contract?.value) {
      setCurrentOpportunity(contract?.value);
      return;
    }
  }, [contract]);

  useEffect(() => {
    if (!currentOpportunity) {
      setIsLeadsterPlusActive(false);
      return;
    }

    dispatch(
      validateLeadsterPlusMenuAccess(
        {
          opportunityId: currentOpportunity,
        },
        alternativeCallBackSuccessLeadsterPlus,
        alternativeCallBackErrorLeadsterPlus
      )
    );
  }, [currentOpportunity]);

  // Verificar documentos obrigatórios quando o contrato mudar
  useEffect(() => {
    handleCheckMandatoryDocuments();
  }, [handleCheckMandatoryDocuments]);

  useEffect(() => {
    const mappedMenuItems = user.permissionCategories.map((permission) => {
      switch (permission.code) {
        case "HOMEPAGE":
          return {
            key: "0",
            icon: (
              <AiOutlineHome
                size={26}
                style={{ marginRight: -10 }}
                color={getIconColor("/home")}
              />
            ),
            onClick: onClickGoToPage("/home"),
            label: intl.formatMessage({ id: "sidebar.homepage" }),
            title: intl.formatMessage({ id: "sidebar.homepage" }),
            "data-test": "HOMEPAGE",
          };
        case "CHECKLIST":
          return {
            key: "2",
            icon: <ListChecks color={getIconColor("/checklist")} />,
            onClick: onClickGoToPage("/checklist"),
            label: intl.formatMessage({ id: "sidebar.checklist" }),
            title: intl.formatMessage({ id: "sidebar.checklist" }),
            "data-test": "CHECKLIST",
          };

        case "EXPOSITORY":
          if (!allowManualAccess) return null;
          return {
            key: "3",
            icon: (
              <BookIcon
                color={getIconColor(`/event-manual/${eventEditionCode}`)}
              />
            ),
            onClick: onClickGoToPage(`/event-manual/${eventEditionCode}`),
            label: intl.formatMessage({ id: "sidebar.exhibitors_manual" }),
            title: intl.formatMessage({ id: "sidebar.exhibitors_manual" }),
          };

        case "IA_CREATOR":
          if (!hasAccessToCreator) return null;
          return {
            key: "4",
            icon: <ImageIcon color={getIconColor("/ai-creator")} />,
            onClick: onClickGoToPage("/ai-creator"),
            label: intl.formatMessage({ id: "sidebar.creator" }),
            title: intl.formatMessage({ id: "sidebar.creator" }),
            "data-test": "AI_CREATOR",
          };

        case "INFORMA_ACADEMY":
          if (!allowAccess || !eventCode) return null;
          return {
            key: "5",
            icon: (
              <Movie color={getIconColor(`/informa-academy/${eventCode}`)} />
            ),
            onClick: onClickGoToPage(`/informa-academy/${eventCode}`),
            label: "Informa Academy",
            title: "Informa Academy",
          };

        case "BILLS":
          return {
            key: "6",
            icon: <Billing color={getIconColor("/billing")} />,
            onClick: () => handleFinancialSingleSignOn(event, contract),
            label: intl.formatMessage({ id: "sidebar.bills" }),
            title: intl.formatMessage({ id: "sidebar.bills" }),
            "data-test": "BILLS",
          };

        case "PROFILE":
          return {
            key: "7",
            icon: <UserCircle color={getIconColor("/user")} />,
            onClick: () =>
              getFirstUrlToPage(items.find((item) => item.path === "/user")),
            label: intl.formatMessage({ id: "sidebar.my_account" }),
            title: intl.formatMessage({ id: "sidebar.my_account" }),
            "data-test": "PROFILE",
          };

        case "SERVICE_PROVIDERS":
          if (user?.role?.type === "SPONSOR_WITHOUT_M2") return null;
          return {
            key: "8",
            icon: <Package color={getIconColor("/associate-company/view")} />,
            onClick: onClickGoToPage("/associate-company/view"),
            label: intl.formatMessage({ id: "service_provider" }),
            title: intl.formatMessage({ id: "service_provider" }),
            "data-test": "SERVICE_PROVIDERS",
          };

        case "DOWNLOAD_DOCUMENTS":
          return {
            key: "9",
            icon: <FileArrowDown color={getIconColor("/document")} />,
            onClick: onClickGoToPage("/document"),
            label: (
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <div>{intl.formatMessage({ id: "documents" })}</div>
                <Tooltip
                  title={intl.formatMessage({
                    id: "documents.mandatory_pending",
                  })}
                >
                  {hasMandatoryDocuments && contract.value && (
                    <MdInfo size={22} color="#EF4444" />
                  )}
                </Tooltip>
              </div>
            ),
            title: intl.formatMessage({ id: "documents" }),
            "data-test": "DOWNLOAD_DOCUMENTS",
          };

        case "CONTRACT":
          return {
            key: "10",
            icon: <Files color={getIconColor("/contract")} />,
            onClick: onClickGoToPage("/contract"),
            label: intl.formatMessage({ id: "contract" }),
            title: intl.formatMessage({ id: "contract" }),
            "data-test": "CONTRACT",
          };

        case "ACCREDITATION":
          return {
            key: "11",
            icon: <IdentificationCard color={getIconColor("/credentials")} />,
            onClick: () =>
              getFirstUrlToPage(
                items.find((item) => item.path === "/credentials")
              ),
            label: intl.formatMessage({ id: "sidebar.credentials" }),
            title: intl.formatMessage({ id: "sidebar.credentials" }),
            "data-test": "ACCREDITATION",
          };

        case "LEADSTER_PLUS":
          if (!isLeadsterPlusActive) return null;
          return {
            key: "12",
            icon: <LoaderFill color={getIconColor("/leadsterplus")} />,
            onClick: () => handleLeadsterPlus(),
            label: intl.formatMessage({ id: "sidebar.leadsterplus" }),
            title: intl.formatMessage({ id: "sidebar.leadsterplus" }),
            "data-test": "LeadsterPlus",
          };

        case "ECOMMERCE":
          return {
            key: "13",
            icon: <Basket color={getIconColor("/ecommerce")} />,
            onClick: onClickGoToPage("/ecommerce"),
            label: intl.formatMessage({ id: "sidebar.ecommerce" }),
            title: intl.formatMessage({ id: "sidebar.ecommerce" }),
            "data-test": "ECOMMERCE",
          };

        case "CONTACT":
          return {
            key: "14",
            icon: <ChatDots color={getIconColor("/contact")} />,
            onClick: onClickGoToPage("/contact"),
            label: intl.formatMessage({ id: "sidebar.contact" }),
            title: intl.formatMessage({ id: "sidebar.contact" }),
            "data-test": "CONTACT",
          };

        case "SYSTEMS":
          if (!isGuestsActive) return null;
          return {
            key: "15",
            icon: <Guests color={getIconColor("/guests")} />,
            onClick: () => handleGuests(),
            label: intl.formatMessage({ id: "sidebar.guests" }),
            title: intl.formatMessage({ id: "sidebar.guests" }),
            "data-test": "SYSTEMS",
          };

        case "FAQ":
          return {
            key: "16",
            icon: <Question color={getIconColor("/faq")} />,
            onClick: onClickGoToPage("/faq"),
            label: intl.formatMessage({ id: "FAQ" }),
            title: intl.formatMessage({ id: "FAQ" }),
            "data-test": "FAQ",
          };

        case "ACCESS_MANAGEMENT":
          return {
            key: "17",
            icon: (
              <GiPositionMarker
                color={getIconColor("/admin/totem-position-configuration")}
              />
            ),
            onClick: onClickGoToPage("/admin/totem-position-configuration"),
            label: intl.formatMessage({ id: "sidebar.manage_totem_positions" }),
            title: intl.formatMessage({ id: "sidebar.manage_totem_positions" }),
            "data-test": "ACCESS_MANAGEMENT",
          };

        default:
          return null;
      }
    });

    const orderedMenuItems = [...mappedMenuItems].sort((itemA, itemB) => {
      if (!itemA) return 1;
      if (!itemB) return -1;
      if (itemA === itemB) return 0;
      return Number(itemA.key) - Number(itemB.key);
    });

    if (adminToken) {
      setMenuItems([
        {
          key: "1",
          icon: <UserSwitch color={getIconColor("/accounts-users")} />,
          onClick: onClickGoToPage("/accounts-users"),
          label: intl.formatMessage({ id: "accounts_users" }),
          title: intl.formatMessage({ id: "accounts_users" }),
          "data-test": "ACCOUNTS_USERS",
        },
        ...orderedMenuItems,
      ]);
      return;
    }

    setMenuItems(orderedMenuItems);
  }, [
    user,
    mainPath,
    intl,
    adminToken,
    event,
    contract,
    isGuestsActive,
    isLeadsterPlusActive,
    allowAccess,
    allowManualAccess,
    eventCode,
  ]);

  return (
    <AntdMenu
      data-test="newUx-sidebarMenu"
      style={{ border: "none" }}
      defaultSelectedKeys={[selectedKey]}
      selectedKeys={[selectedKey]}
      multiple={false}
      mode="inline"
      items={menuItems}
    />
  );
};

export default Menu;
